module.exports = __webpack_public_path__ + "static/select1-574af216804c3ad180cb05a42586ec3b.png";